import React, { useState } from "react";
import { startOfDay, endOfDay } from "date-fns";
import Sidebar from "../Components/SideBar";
import { useAuth } from "react-oidc-context";
import CustomerServiceWindow from "../Components/Windows/customerServiceWindow";
import DateRangeComp from "../Components/DateRangeComp";
import { SignalRContext } from "../App";

function wrapContent(auth, content) {
  switch (auth.activeNavigator) {
    case "signinSilent":
      return <div>Signing you in...</div>;
    case "signoutRedirect":
      return <div>Signing you out...</div>;
  }

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return <React.Fragment>{content()}</React.Fragment>;
  }
  auth.signinRedirect();
}

function CustomerServiceDash() {
  const auth = useAuth();

  const [refreshKey, setRefreshKey] = useState(0);

  const [range, setRange] = useState(null);

  const handleRangeChange = (selection) =>
    setRange({
      start: startOfDay(selection[0].startDate),
      end: endOfDay(selection[0].endDate),
    });

  SignalRContext.useSignalREffect(
    "CustomerServiceDataUpdated",
    () => {
      setRefreshKey((prev) => prev + 1);
    },
    [],
  );

  const content = () => (
    <React.Fragment>
      <div className="staticElement">
        <Sidebar />
      </div>

      <div className="window">
        <div className="customerService__block-top">
          <DateRangeComp setStart={handleRangeChange} />
        </div>
        <CustomerServiceWindow key={refreshKey} range={range} />
      </div>
    </React.Fragment>
  );

  return <div className="parentDiv">{wrapContent(auth, content)}</div>;
}

export default CustomerServiceDash;
